import React from 'react'

export const formatCurrency = (amount: number) => amount.toFixed(2).toLocaleString()

type CurrencyWithColorProps = { amount: number }

export const CurrencyWithColor: React.FC<CurrencyWithColorProps> = ({ amount }) =>
    <span style={{ color: amount < 0 ? 'red' : undefined }}>{formatCurrency(amount)}</span>

export type CostDetailProps = { label: string, subLabel?: string, amount: number }

export const CostDetail: React.FC<CostDetailProps> = ({ label, subLabel, amount }) =>
    <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%', alignItems: 'center' }}>
        <div style={{ width: '6rem', textAlign: 'right' }}><CurrencyWithColor amount={amount} /></div>
        <div style={{ fontWeight: 'bold', width: '10.5rem', textAlign: 'left' }}>
            <p style={{ margin: 0 }}>{label}</p>
            {subLabel && <p style={{ fontWeight: 'normal', margin: 0, fontSize: '.75em' }}>{subLabel}</p>}
        </div>
    </div>

export type CostDetailCollectionProps = { details: CostDetailProps[] }

export const CostDetailCollection: React.FC<CostDetailCollectionProps> = ({ details }) =>
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 30, marginBottom: 30, gap: 5 }}>
        {details.map((d, i) => <CostDetail key={i} {...d} />)}
    </div>
